import React from 'react'
import { observer } from 'mobx-react-lite'
import { add } from 'date-fns'

import { DatePickerCell } from './DatePickerCell'

import { useLogic } from '../../../hooks/storeHook'

import { dateUtils, tryFromUnixTime } from '../../../common/dateTimeUtility'

import { MyRowProps } from '../../../types/tableTypes'
import { UserModel } from '../../../server/mpsklad_core/Models/UserModel'

export const LastPaymentDateCell =
  observer(
    ({row}: MyRowProps<UserModel>) => {
      const {setUserLastPaymentDate} = useLogic()

      const maxDate = dateUtils.now
      const minDate = add(maxDate, {years: -2})

      const onDateChange =
        async (newDate: Date | null) => {
          try {
            await setUserLastPaymentDate(row.id, newDate)
          } catch (e) {
            console.log('Failed to change lastPaymentDate', e)
          }
        }

      return (
        <DatePickerCell
          value={tryFromUnixTime(row.lastPaymentDate) ?? null}
          minDate={minDate}
          maxDate={maxDate}
          onChange={onDateChange}
        />
      )
    })